<template>
    <div class="large-countdown">
        <div class="row">
            <div class="col-md-12">
                <div class="countdown">
                    <div class="time-amount">
                        <span class="time-left-days">{{ daysDisplay }}</span>
                        <span class="time-value">
                            <Translate translationKey="time.days"
                                       fallback="Days" />
                        </span>
                    </div>
                    <div class="time-amount">
                        <span class="time-left-hours">{{ hoursDisplay }}</span>

                        <span class="time-value">
                            <Translate translationKey="time.hours"
                                       fallback="Hours" />
                        </span>
                    </div>
                    <div class="time-amount">
                        <span class="time-left-minutes">{{ minutesDisplay }}</span>
                        <span class="time-value">
                            <Translate translationKey="time.min"
                                       fallback="min" />.
                        </span>
                    </div>
                    <div class="time-amount">
                        <span class="time-left-seconds">{{ secondsDisplay }}</span>
                        <span class="time-value">
                            <Translate translationKey="time.sec"
                                       fallback="sec" />.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from 'vue';

    interface Props {
        remainingTime: number;
    }
    const props = defineProps<Props>();

    const timer = ref(props.remainingTime);

    const secondsDisplay = ref(null);
    const minutesDisplay = ref(null);
    const hoursDisplay = ref(null);
    const daysDisplay = ref(null);
    const isVisible = ref(true);

    const lastTime = ref(0);
    const animationFrameId = ref<number | null>(null);

    const updateTimerDisplay = () => {
        const days = Math.floor(timer.value / 60 / 60 / 24);
        const hours = Math.floor((timer.value / 60 / 60)) - (days * 24);
        const minutes = Math.floor((timer.value / 60) % 60);
        const seconds = Math.floor(timer.value % 60);

        secondsDisplay.value = seconds < 10 ? `0${seconds}` : seconds;
        minutesDisplay.value = minutes < 10 ? `0${minutes}` : minutes;
        hoursDisplay.value = hours < 10 ? `0${hours}` : hours;
        daysDisplay.value = days < 10 ? `${days}` : days;
    };

    const updateTimer = () => {
        timer.value -= 1;

        if (timer.value > 0) {
            updateTimerDisplay();
        } else {
            cancelAnimationFrame(animationFrameId.value);
            lastTime.value = 0;
            timer.value = 0;
            isVisible.value = false;
        }
    };

    const updateTimerWithRAF = (timestamp: number) => {
        if (!lastTime.value) {
            lastTime.value = timestamp;
        }

        if (timestamp - lastTime.value >= 1000) {
            lastTime.value = timestamp;
            updateTimer();
        }

        if (timer.value > 0) {
            animationFrameId.value = requestAnimationFrame(updateTimerWithRAF);
        }
    };

    onMounted(() => {
        updateTimerDisplay();
        animationFrameId.value = requestAnimationFrame(updateTimerWithRAF);
    });

    onBeforeUnmount(() => {
        if (animationFrameId.value !== null) {
            cancelAnimationFrame(animationFrameId.value);
        }
    });
</script>

<style scoped lang="scss">
.large-countdown {
    .countdown {
        display: inline-block;
    }
}
</style>
